import { maxWidth } from '@/assets/styles/mixins.css.js'
import styled from 'styled-components'
import vars from '@/assets/styles/vars'

const MainSpecialists = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 40px;

  ${maxWidth(vars.breakpoints.xsDesktop)`
    grid-template-columns: 1fr;
    gap: 30px;
    margin-bottom: 30px;
  `}
`

MainSpecialists.Item = styled.li`
overflow:hidden;
${maxWidth(vars.breakpoints.tablet)`
  &:nth-child(n + 3) {
    display:none;
  }
`} 
`

MainSpecialists.Info = styled.div`
  --spec-info-max-lines: 5;

  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  height: 100%;
  padding: 32px 30px 28px;
  color: #fff;
  background: var(--color-main);

  b {
    display: block;
    width: 100%;
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  p {
    display: block;
    display: -webkit-box;
    max-height: calc(16px * 1.4 * var(--spec-info-max-lines));
    -webkit-line-clamp: var(--spec-info-max-lines);
    -moz-line-clamp: var(--spec-info-max-lines);
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;
    line-height: 1.4;
  }

  ${maxWidth(1100)`
    --spec-info-max-lines: 4;
  `}

  ${maxWidth(vars.breakpoints.tablet)`
    display: none;
  `}
`

export default MainSpecialists
